import { Label } from '@mui/icons-material'
import { Box, Button, Checkbox, CircularProgress, MenuItem, Popover, TextField, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { font } from '../../styles/font'
import { useApplicationContext } from '../../context/ApplicationContext'
import AddUpdateLabelDialog from '../dialog/AddUpdatelabelDialog'
import { ModulePath, Severity } from '../../constant/ApplicationVariables'
import { useNavigate } from 'react-router-dom'
import { addLabel_API, getLabelList_API } from '../../api/controller/SettingsController'
import useErrorHandler from '../../api/errorHandler/useErrorHandler'
import { HttpStatusCode } from 'axios'

export default function LabelButton({ selectedList, handleApply, handleClose }) {
    const { labelList, setLabelList, activeProject, handleSnackbar } = useApplicationContext();

    const theme = useTheme();
    const navigate = useNavigate();
    const errorHandler = useErrorHandler();

    const [loading, setLoading] = useState(false);
    const [openLabelDialog, setOpenLabelDialog] = useState(false);

    const [labelAnchorEl, setLabelAnchorEl] = useState(null);
    const [selectedLabels, setSelectedLabels] = useState([]);

    const [searchText, setSearchText] = useState("");
    const [isLabelEditMode, setIsLabelEditMode] = useState(false);
    const [currentLabelData, setCurrentLabelData] = useState(null);
    const [labelData, setLabelData] = useState({
        name: "",
        color: "#FF5733",
    });



    const handleToggleLabelPopup = (e) => {

        e && e.stopPropagation();

        if (!labelAnchorEl) {
            setLabelAnchorEl(e.currentTarget);
        } else {
            setLabelAnchorEl(null);
        }
    }


    const handleChangeLabel = (label) => {
        let list = selectedLabels ? [...selectedLabels] : [];

        const index = list?.findIndex((item) => item?.name === label?.name);

        if (index > -1) {
            list.splice(index, 1);
        } else {
            list.push(label);
        }

        setSelectedLabels(list);
    }

    const handleOpenLabelAddUpdate_Dialog = (isEdit, item) => {
        setIsLabelEditMode(isEdit);
        setOpenLabelDialog(true);


        if (item && isEdit) {
            setCurrentLabelData(item);
            setLabelData({
                name: item?.name,
                color: item?.colorCode,
            });
        }

    }

    const handleLabelUpdate = () => {
        handleApply(selectedLabels);


        setTimeout(() => {
            handleToggleLabelPopup();
            setSearchText("");
        }, 1100)
    }




    const handleCloseDialog = () => {
        setOpenLabelDialog(false);
        setIsLabelEditMode(false);
        setCurrentLabelData(null);

        setLabelData({
            name: "",
            color: "#FF5733",
        });
    }

    const handleGetList = async () => {

        try {

            setLoading(true)


            let body = {
                name: activeProject?.name,
            }

            let query = new URLSearchParams(body).toString();

            const response = await getLabelList_API(query);

            console.log(response, " response in updateprofile")

            if (response) {
                errorHandler(response, setLoading);
            }

            if (response.status === HttpStatusCode.Ok) {
                setLabelList(response.data);

            }

        } catch (error) {
            console.log(error, error?.message, "login errorr");
            handleSnackbar(String(error), Severity.error);
        } finally {
            setTimeout(() => {
                setLoading(false);

            }, 1000);
        }
    }

    const handleAddlabel = async () => {

        try {

            setLoading(true);


            let body = {
                name: searchText,
                // colorCode: color,
                projectName: activeProject?.name,
            }

            const response = await addLabel_API(body);

            console.log(response, " response in updateprofile")

            if (response) {
                errorHandler(response, setLoading);
            }

            if (response.status === HttpStatusCode.Ok) {

                handleCloseDialog();
                handleGetList();


                handleSnackbar(response?.data?.message, Severity.success);
            }

        } catch (error) {
            console.log(error, error?.message, "login errorr");
            handleSnackbar(String(error), Severity.error);
        } finally {
            setTimeout(() => {
                setLoading(false);

            }, 1000);
        }
    }

    useEffect(() => {
        setSelectedLabels(selectedList);
    }, [selectedList]);


    return (
        <Box>
            <Button size="small" variant="outlined" startIcon={<Label />} disabled={false} sx={{ background: labelAnchorEl ? theme.palette.highlight.main : "" }} onClick={handleToggleLabelPopup}>Labels</Button>



            {/* add / update dialog */}
            <AddUpdateLabelDialog
                open={openLabelDialog}
                data={currentLabelData}
                isEdit={isLabelEditMode}
                handleClose={handleCloseDialog}
            />

            {/* label list */}
            <Popover
                id="label-list"
                open={Boolean(labelAnchorEl)}
                anchorEl={labelAnchorEl}
                slotProps={{
                    paper: {
                        elevation: 0,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            mt: 1.5,
                            '& .MuiAvatar-root': {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1,
                            },
                            '&::before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: 0,
                                left: 14,
                                width: 10,
                                height: 10,
                                bgcolor: 'background.paper',
                                transform: 'translateY(-50%) rotate(45deg)',
                                zIndex: 0,
                            },
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                onClose={handleToggleLabelPopup}
            >
                <Box className="flex flex-col px-2 py-2">

                    {/* header */}
                    <Box className="flex flex-col gap-1 px-4 py-2 border-b">
                        <Typography fontSize={font.size.fs_5} color="textPrimary" className="">Labels</Typography>
                        <TextField variant="standard" placeholder="Search label" size="small" value={searchText} onChange={(e) => setSearchText(e.target.value)} />
                    </Box>

                    {/* body */}
                    <Box className="flex flex-col px-2 py-2 relative  max-h-[40vh] overflow-y-auto">

                        {loading && <Box className=" flex-1 flex items-center justify-center absolute  top-0 left-0 right-0 bottom-0 backdrop-blur-sm w-full h-full bg-white rounded-lg opacity-80" >
                            <CircularProgress size={20} />
                        </Box>}

                        {
                            labelList?.filter((label) => label?.name?.toLowerCase()?.includes(searchText?.toLowerCase()))?.length === 0 ? (
                                <Box>
                                    <Button size="small" variant="text" color="primary" sx={{ color: theme.palette.text.primary }} fullWidth onClick={() => { handleAddlabel() }}>"{searchText}" (Create new) </Button>

                                </Box>
                            ) :
                                (
                                    labelList?.filter((label) => label?.name?.toLowerCase()?.includes(searchText?.toLowerCase()))?.map((label, index) => (
                                        <MenuItem key={index} sx={{ padding: 0 }} >
                                            <Box className="flex-1 flex items-center gap-2 w-full">
                                                <Checkbox size="small" checked={selectedLabels?.some(selectedLabel => selectedLabel?.name === label?.name) ? true : false} onChange={() => handleChangeLabel(label)} />
                                                <Label sx={{ color: label?.colorCode }} />
                                                <Typography fontSize={font.size.fs_5} color="textPrimary">{label?.name}</Typography>
                                            </Box>
                                        </MenuItem>
                                    ))
                                )
                        }
                    </Box>

                    {/* footer */}
                    <Box className="flex flex-col gap-4  px-4 py-2 border-t">
                        {false && <Button size="small" variant="outlined" color="primary" sx={{ color: theme.palette.text.primary }} fullWidth onClick={handleOpenLabelAddUpdate_Dialog}>Add </Button>}

                        <Button size="small" variant="contained" color="secondary" sx={{ color: theme.palette.secondary.contrastText }} fullWidth onClick={handleLabelUpdate}>Apply </Button>
                        <Button size="small" variant="text" sx={{ color: theme.palette.secondary.main }} fullWidth onClick={() => navigate(ModulePath.configuration)}> Manage Labels </Button>
                    </Box>


                </Box>

            </Popover>
        </Box>
    )
}
